import SpecialSale from 'src/dispensary/specials/sale';
import { CoreMenuLayout } from 'components/layouts/core-menu-layout';

SpecialSale.layout = CoreMenuLayout;
export default SpecialSale;
